// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"9fa620c5","998":"edc3dfa3"}[chunkId] + ".chunk.js";
};